export class EntInitialFilter {
  page: number;
  size: number;
  name?: string | null;
  deleted?: boolean | null;
  departmentIds?: number[] | null;

  constructor(init?:Partial<EntInitialFilter>) {
    this.deleted = false;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}
